import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fileSize',
    standalone: true
})
export class FileSizePipe implements PipeTransform {
    transform(value: number): string {
        if (value == null || isNaN(value)) return '';
        const giga: number = 1024 * 1024 * 1024;
        const mega: number = 1024 * 1024;
        if (value >= giga) {
            return (value / giga).toFixed(2) + ' Go';
        } else if (value >= mega) {
            return (value / mega).toFixed(0) + ' Mo';
        } else {
            return (value / 1024).toFixed(0) + ' Ko';
        }
    }
}
